/* eslint-disable no-param-reassign */
import getDefaultState from './util';
import { capi } from '../../client/setup';

export default {
  namespaced: true,

  state: {
    ...getDefaultState(),
  },

  getters: {
    orderConfirmationResponse: (state) => state.orderConfirmationResponse,
    isSerialRmaAssociated: (state) => state.isSerialRmaAssociated,
  },

  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState());
    },
    setOrderConfirmationResponse(state, response) {
      state.orderConfirmationResponse = response;
    },
    setIsSerialRmaAssociated(state, isSerialRmaAssociated) {
      state.isSerialRmaAssociated = isSerialRmaAssociated;
    },
  },

  actions: {
    reset({ commit }) {
      commit('reset');
    },

    async createExchangeOrder({ commit, rootGetters }, payload = {}) {
      try {
        const locale = rootGetters['customer/suppliedFormData']?.selectedCountryRegion?.locale;
        const { data: { webOrderId } } = await capi.post(`createOrder/${locale}`, payload);
        commit('setOrderConfirmationResponse', webOrderId);
      } catch (e) {
        commit('setOrderConfirmationResponse', null);
      }
    },

    async checkSerialRmaAssociation({ commit, rootGetters }, payload = {}) {
      try {
        const locale = rootGetters['customer/suppliedFormData']?.selectedCountryRegion?.locale;

        payload.locale = locale; //eslint-disable-line

        const { data: { hasRmaAssociated } } = await capi.post('isRmaAssociated', payload);
        commit('setIsSerialRmaAssociated', hasRmaAssociated);
      } catch (e) {
        commit('setIsSerialRmaAssociated', null);
      }
    },
  },
};
